import * as Yup from "yup";

export const signInDetailsObject = {
  email: "",
  password: "",
  mobile: "",
  otp: "",
  rememberMe: false,
};

export function objectFromFormData(formData) {
  return {
    email: formData.email,
    password: formData.password,
  };
}
export const emailValidationSchema = Yup.object().shape({
  email: Yup.string().required("Email is required"),
  password: Yup.string().required("Password is required"),
});

export const otpValidationSchema = Yup.object().shape({
  mobile: Yup.string()
    .required("Mobile number is required")
    .matches(/^[6-9]\d{9}$/, "Enter valid 10-digit mobile number"),
  otp: Yup.string().required("OTP is required"),
});
